/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const FlightYellowIcon = ({ cls }: { cls?: string }) => {
  return (
    <svg
      width="190"
      height="306"
      viewBox="0 0 190 306"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        d="M169.589 218.533L169.589 219.033L170.089 219.033L178.5 219.033L178.5 277.478C178.5 285.501 171.967 292 163.91 292L127.733 292C127.464 274.232 112.907 259.909 95 259.909C77.0931 259.909 62.5358 274.232 62.2673 292L26.0897 292C18.0326 292 11.5 285.501 11.5 277.478L11.5 219.033L21.2851 219.033L21.7851 219.033L21.7851 218.533L21.7851 207.563L21.7851 207.063L21.2851 207.063L11.5 207.063L11.5 33.5215C11.5 25.5065 18.0328 19 26.0897 19L62.2673 19C62.5356 36.7749 77.0856 51.0981 95 51.0981C112.914 51.0981 127.464 36.7749 127.733 19L163.91 19C171.967 19 178.5 25.5065 178.5 33.5215L178.5 207.063L170.089 207.063L169.589 207.063L169.589 207.563L169.589 218.533ZM42.0459 218.533L42.0459 219.033L42.5459 219.033L63.7994 219.033L64.2994 219.033L64.2994 218.533L64.2994 207.563L64.2994 207.063L63.7994 207.063L42.5459 207.063L42.0459 207.063L42.0459 207.563L42.0459 218.533ZM84.5602 218.533L84.5602 219.033L85.0602 219.033L106.314 219.033L106.814 219.033L106.814 218.533L106.814 207.563L106.814 207.063L106.314 207.063L85.0602 207.063L84.5602 207.063L84.5602 207.563L84.5602 218.533ZM127.074 218.533L127.074 219.033L127.574 219.033L148.835 219.033L149.335 219.033L149.335 218.533L149.335 207.563L149.335 207.063L148.835 207.063L127.574 207.063L127.074 207.063L127.074 207.563L127.074 218.533Z"
        fill="url(#paint0_linear_6760_7658)"
        stroke="url(#paint1_linear_6760_7658)"
      />

      <path
        d="M99.1477 179.361C97.592 180.744 95.5178 181.781 93.2708 181.781C88.6038 181.781 84.9739 177.979 82.8997 174.521C80.8254 170.892 79.4426 166.225 79.4426 162.768L79.4426 145.31L50.4036 128.716L49.0208 128.024L49.0208 126.469L49.0208 109.875L49.0208 106.072L52.4778 107.109L79.4426 114.888L79.4426 107.109L69.4172 99.5039L68.3801 98.8125L68.3801 97.4297L68.3801 86.3672L68.3801 82.7373L71.6643 83.6016L93.2708 88.96L114.704 83.6016L118.161 82.7373L118.161 86.3672L118.161 97.4297L118.161 98.8125L116.951 99.5039L107.099 107.109L107.099 114.888L133.891 107.109L137.521 106.072L137.521 109.875L137.521 126.469L137.521 128.024L135.965 128.716L107.099 145.31L107.099 162.768C107.099 166.397 105.543 170.892 103.296 174.521C102.259 176.423 100.876 178.151 99.1477 179.361ZM98.6292 171.583C100.531 168.645 101.568 165.015 101.568 162.768L101.568 143.754L101.568 142.198L102.95 141.334L131.99 124.74L131.99 113.505L105.025 121.11L101.568 122.147L101.568 118.518L101.568 105.727L101.568 104.344L102.605 103.479L112.63 96.0469L112.63 89.8242L93.7893 94.4912L93.2708 94.6641L92.5793 94.4912L73.9114 89.8242L73.9114 96.0469L83.7639 103.479L84.9739 104.344L84.9739 105.727L84.9739 118.518L84.9739 122.147L81.344 121.11L54.552 113.505L54.552 124.74L83.4182 141.334L84.9739 142.198L84.9739 143.754L84.9739 162.768C84.9739 165.015 85.8381 168.645 87.7395 171.583C89.6409 174.694 91.5422 176.25 93.2708 176.25C93.9622 176.25 94.8264 175.904 95.6907 175.04C96.7278 174.349 97.7649 173.139 98.6292 171.583Z"
        fill="#F0F0F0"
      />

      <defs>
        <linearGradient
          id="paint0_linear_6760_7658"
          x1="179"
          y1="18.5"
          x2="-65.1969"
          y2="168.227"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FDDFAB" stop-opacity="0.5" />

          <stop offset="0.3" stop-color="#F5C461" stop-opacity="0.6" />

          <stop offset="1" stop-color="#FDDFAB" stop-opacity="0.7" />
        </linearGradient>

        <linearGradient
          id="paint1_linear_6760_7658"
          x1="179"
          y1="18.5"
          x2="-65.1969"
          y2="168.227"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FDDFAB" />
          <stop offset="0.3" stop-color="#F5C461" />
          <stop offset="1" stop-color="#FDDFAB" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default FlightYellowIcon;
